export const FAQ = [
  {
    q: "Qu'est-ce que la planification financière et pourquoi est-elle importante?",
    a: "La planification financière consiste à faire le point sur votre situation (revenus, dépenses, épargne, protections) et à définir des objectifs réalistes. Elle aide à prendre des décisions plus éclairées et à mieux se préparer aux imprévus comme aux projets futurs.",
  },
  {
    q: "Comment l'optimisation fiscale peut-elle m'aider?",
    a: "L'optimisation fiscale vise à utiliser, dans le respect des règles en vigueur, les outils et mesures auxquels vous pourriez avoir droit. Les possibilités varient selon chaque situation et doivent être validées avec les professionnels appropriés (comptable, fiscaliste). Aucun résultat n'est garanti.",
  },
  {
    q: "Je suis un jeune professionnel. Est-ce trop tôt pour commencer?",
    a: "Non. Comprendre ses finances tôt permet de bâtir de bonnes habitudes : un fonds d'urgence, une protection de son revenu et une épargne régulière, même modeste.",
  },
  {
    q: "De quelle assurance ai-je réellement besoin?",
    a: "Cela dépend de votre situation personnelle et professionnelle. Une analyse des besoins, réalisée par un professionnel dûment autorisé, permet de déterminer les protections pertinentes pour vous.",
  },
  {
    q: "En quoi STRUKTIV est-il différent d'une banque?",
    a: "STRUKTIV n'est pas une institution financière. Nous sommes un collectif hybride qui combine éducation financière et accompagnement stratégique, avec une approche simple et humaine adaptée aux professionnels de l'image, de la beauté et du bien-être.",
  },
  {
    q: "Je suis entrepreneur. Pouvez-vous m'accompagner avec mes finances d'entreprise?",
    a: "Oui, nous accompagnons les travailleurs autonomes et les entrepreneurs incorporés afin de mieux comprendre leurs finances et d'explorer des stratégies adaptées, en collaboration avec les professionnels appropriés au besoin.",
  },
  {
    q: "La première consultation est-elle gratuite?",
    a: "Oui. La première rencontre sert à comprendre votre situation, vos objectifs et les possibilités qui s'offrent à vous, sans engagement.",
  },
  {
    q: "Comment fonctionne le questionnaire de forfaits personnalisés?",
    a: "Vous choisissez votre secteur et votre métier, puis répondez à quelques questions. Des règles approuvées par STRUKTIV suggèrent ensuite l'un de nos quatre forfaits. Cette suggestion est informative et préliminaire : elle ne remplace pas une analyse complète de votre situation.",
  },
  {
    q: "Mes informations personnelles sont-elles protégées?",
    a: "Vos renseignements sont transmis de façon chiffrée (HTTPS), conservés dans une base de données sécurisée et accessibles uniquement aux personnes autorisées. Nous ne demandons jamais de NAS ni de coordonnées bancaires. Consultez notre politique de confidentialité pour en savoir plus.",
  },
];
